/* tslint:disable */
/* eslint-disable */
/**
 * BloomRegistration.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Payment,
    PaymentFromJSON,
    PaymentFromJSONTyped,
    PaymentToJSON,
} from './Payment';
import {
    TrusteeUserMapping,
    TrusteeUserMappingFromJSON,
    TrusteeUserMappingFromJSONTyped,
    TrusteeUserMappingToJSON,
} from './TrusteeUserMapping';
import {
    UserStudentMapping,
    UserStudentMappingFromJSON,
    UserStudentMappingFromJSONTyped,
    UserStudentMappingToJSON,
} from './UserStudentMapping';

/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {string}
     * @memberof User
     */
    id?: string | null;
    /**
     * 
     * @type {number}
     * @memberof User
     */
    type?: number;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    emailAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    password?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    sms?: string | null;
    /**
     * 
     * @type {Array<UserStudentMapping>}
     * @memberof User
     */
    userStudentMappings?: Array<UserStudentMapping> | null;
    /**
     * 
     * @type {Array<TrusteeUserMapping>}
     * @memberof User
     */
    trusteeUserMappings?: Array<TrusteeUserMapping> | null;
    /**
     * 
     * @type {Array<Payment>}
     * @memberof User
     */
    payments?: Array<Payment> | null;
}

export function UserFromJSON(json: any): User {
    return UserFromJSONTyped(json, false);
}

export function UserFromJSONTyped(json: any, ignoreDiscriminator: boolean): User {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'emailAddress': !exists(json, 'emailAddress') ? undefined : json['emailAddress'],
        'password': !exists(json, 'password') ? undefined : json['password'],
        'sms': !exists(json, 'sms') ? undefined : json['sms'],
        'userStudentMappings': !exists(json, 'userStudentMappings') ? undefined : (json['userStudentMappings'] === null ? null : (json['userStudentMappings'] as Array<any>).map(UserStudentMappingFromJSON)),
        'trusteeUserMappings': !exists(json, 'trusteeUserMappings') ? undefined : (json['trusteeUserMappings'] === null ? null : (json['trusteeUserMappings'] as Array<any>).map(TrusteeUserMappingFromJSON)),
        'payments': !exists(json, 'payments') ? undefined : (json['payments'] === null ? null : (json['payments'] as Array<any>).map(PaymentFromJSON)),
    };
}

export function UserToJSON(value?: User | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'type': value.type,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'emailAddress': value.emailAddress,
        'password': value.password,
        'sms': value.sms,
        'userStudentMappings': value.userStudentMappings === undefined ? undefined : (value.userStudentMappings === null ? null : (value.userStudentMappings as Array<any>).map(UserStudentMappingToJSON)),
        'trusteeUserMappings': value.trusteeUserMappings === undefined ? undefined : (value.trusteeUserMappings === null ? null : (value.trusteeUserMappings as Array<any>).map(TrusteeUserMappingToJSON)),
        'payments': value.payments === undefined ? undefined : (value.payments === null ? null : (value.payments as Array<any>).map(PaymentToJSON)),
    };
}

